import { render } from "./returnVisit.vue?vue&type=template&id=12a135bc&scoped=true&ts=true"
import script from "./returnVisit.vue?vue&type=script&lang=ts"
export * from "./returnVisit.vue?vue&type=script&lang=ts"

import "./returnVisit.vue?vue&type=style&index=0&id=12a135bc&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12a135bc"]])

export default __exports__